import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import Cookies from "js-cookie";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import PrivacyPolicyModal from "./privacyPolicy/PrivacyPolicyModal";
import SaasModal from "./privacyPolicy/SaasModel";
import EulaModal from "./privacyPolicy/eulaModal";

import styles from "./Login.module.scss";

export default function Login() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showSAASModal, setShowSAASModal] = useState(false);
  const [showEulaModal, setShowEulaModal] = useState(false);
  const [hasGuestRef, setHasGuestRef] = useState(false);
  const [privacyContent, setPrivacyContent] = useState("");
  const [saasContent, setSaasContent] = useState("");
  const [eulaContent, setEulaContent] = useState("");


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const guestRef = params.get("guest_purchase_reference");
    setHasGuestRef(Boolean(guestRef));
    if (guestRef) {
      localStorage.setItem("guest_purchase_reference", guestRef);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const guestRef = params.get("guest_purchase_reference");
    if (guestRef) {
      localStorage.setItem("guest_purchase_reference", guestRef);
    }
  }, []);

  const login = useMutation({
    mutationFn: () =>
      axios.get(`/auth/get_dentally_request_auth_link?capture=default`),
    onSuccess: (res) => window.location.replace(res.data),
  });

  const loadDoc = async (id: number, setter: any, modalSetter: any) => {
    try {
      const res = await axios.get(`document_agreement/${id}`);
      setter(res.data.document);
    } catch {
      setter("Failed to load document.");
    } finally {
      modalSetter(true);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.centerWrap}>
        <div className={styles.card}>
          {/* LEFT */}
          <div className={styles.left}>
            <div className={styles.brand}>
              <img src="/logo.png" className={styles.logo} alt="Medicube" />

              <div className={styles.tagline}>
                <div className={styles.orangeText}>
                  Streamlined Consent Management
                </div>
                <div className={styles.captionText}>
                  Connect with Dentally to automatically sync patient and treatment data for seamless consent workflows.
                </div>
              </div>
            </div>

            <div className={styles.imageWrap}>
              <img src="doc2.png" className={styles.image} alt="Doctors" />
            </div>
          </div>

          {/* RIGHT */}
          <div className={styles.right}>
            <button
              className={styles.aboutBtn}
              onClick={() => {
                window.location.href = "https://medicube.site/";
              }}
            >
              About
            </button>

            <div className={styles.content}>
              <h1>Welcome!</h1>

              <p className={styles.subText}>
                Your Dentally data will be used to prefill patient and treatment plan details.
              </p>



               {hasGuestRef && (
                <div style={{ marginBottom: 12 }}>
                 <Alert
                      severity="warning"
                      variant="outlined"
                      sx={{
                        borderRadius: 10,        
                        borderWidth: 1.5,
                        px: 2,
                        py: 1.5,
                        alignItems: "flex-start",
                        "& .MuiAlertTitle-root": { fontWeight: 800, mb: 0.5 },
                        "& .MuiAlert-icon": { mt: "2px" },
                      }}
                    >
                    <AlertTitle>Important notice</AlertTitle>
                     When you connect to Dentally via MediCube for the first time, 
                     Dentally may display a warning regarding third-party access and data security. 
                     This is a standard message shown when authorising an external application.
                    <br />
                    <br />
                    You have nothing to worry about.
                    Medicube only requests the minimum information required to make your workflow seemless,
                      and we take reasonable, 
                    industry-standard measures to safeguard your information.  
                    You can find more information in our {" "}
                      <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => loadDoc(3, setPrivacyContent, setShowPrivacyModal)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          loadDoc(3, setPrivacyContent, setShowPrivacyModal);
                        }
                      }}
                    >
                      Privacy Policy
                    </span>
                    .
                  </Alert>
                </div>
              )}
              <Button
                className={styles.loginBtn}
                onClick={() => login.mutate()}
              >
                Login via <img src="/dentally-Photoroom.png" />
              </Button>

              <p className={styles.privacy}>
                By continuing, you agree to our{" "}
                <span
                  onClick={() =>
                    loadDoc(3, setPrivacyContent, setShowPrivacyModal)
                  }
                >
                  Privacy Policy
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className={styles.footer}>
        <img src="/logo.png" />
        <p>© 2024 Medicube. All rights reserved.</p>
        <div className={styles.links}>
          <span onClick={() => loadDoc(3, setPrivacyContent, setShowPrivacyModal)}>
            Privacy Policy
          </span>
          |
          <span onClick={() => loadDoc(2, setSaasContent, setShowSAASModal)}>
            SAAS
          </span>
          |
          <span onClick={() => loadDoc(1, setEulaContent, setShowEulaModal)}>
            EULA
          </span>
        </div>
      </footer>

      <PrivacyPolicyModal
        open={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
        content={privacyContent}
      />
      <SaasModal
        open={showSAASModal}
        onClose={() => setShowSAASModal(false)}
        content={saasContent}
      />
      <EulaModal
        open={showEulaModal}
        onClose={() => setShowEulaModal(false)}
        content={eulaContent}
      />
    </div>
  );
}
